import { ViteSSG } from 'vite-ssg';
import { setupLayouts } from 'virtual:generated-layouts';
import type { UserModule } from './types';
import { routes } from 'vue-router/auto-routes';
import App from './App.vue';
import './utils/yupConfig';

import '@openvue/openicons/primeicons.css';
import './style.css';

export const createApp = ViteSSG(
    App,
    {
        routes: setupLayouts(routes),
        base: '/'
    },
    (ctx) => {
        Object.values(
            import.meta.glob<{ install: UserModule }>('./modules/*.ts', {
                eager: true
            })
        ).forEach((i) => i.install?.(ctx));
        ctx.router.onError((err, to) => {
            console.error(err);
            if (typeof window !== 'undefined') {
                window.location.href = to.fullPath;
            }
        });
    }
);
